<template>
    <div :key="companyId" class="page-content proiectul-meu-wrapper">
        <SketchBreadcrumb pageName="Proiectul Meu"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box flex space-between align-center">
                <div ref="scrollTo">
                    <h3 class="module-title">Completează aici detalii cu privire la proiectul tău</h3>
                    <p>Această secțíune cuprinde informațiile despre proiectul tău. Toate informațiile sunt necesare în generarea documentelor / anexelor ce însoțesc cererea de finanțare șî contribuie la
                        personalizarea modulelor următoare, astfel încât procesul de scriere să fie unul simplu și intuitiv.</p>
                </div>
                <img src="@/assets/images/M3/M3Sketch/warning-sign.png" class="warning-sign">
            </div>
            <TitlulProiectului :projectTitle="projectTitle" @formComplete="completePage('titlu', true)" @formIncomplete="completePage('titlu', false)"></TitlulProiectului>
            <CAENEligibil :caen="eligibleCAEN" :caenProps="caenEligibil" @formComplete="completePage('caen', true)" @formIncomplete="completePage('caen', false)" @updateData="$emit('updateData')"></CAENEligibil>
            <AjutoareStat :state_aids="state_aids" :allData="allData" :ajutoareData="ajutoareData" :statusIMM="statusIMM" :statusIMMMessage="statusIMMMessage" @formComplete="completePage('ajutoareStat', true)" @getAllData="$emit('achizitiiChanged')" @formIncomplete="completePage('ajutoareStat', false)"></AjutoareStat>
            <LocatieImplementare :acquisitions="acquisitions" :location_address="location_address" @formComplete="completePage('achizitii', true)" @formIncomplete="completePage('achizitii', false)"></LocatieImplementare>
            <AsigurareGDPR :gdpr_info="gdpr" @formComplete="completePage('asigurareGdpr', true)" @formIncomplete="completePage('asigurareGdpr', false)"></AsigurareGDPR>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>
        <ChangeRoutePopup :schimbaModal="showModal"
                          @hideTempModal="showModal = false"
                          @changeRoute="leavePage($event)"
        ></ChangeRoutePopup>
    </div>
</template>

<script>
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import TitlulProiectului from '../components/proiect-forms/TitlulProiectului'
    import CAENEligibil from '../components/proiect-forms/CAENEligibil'
    import ContulBancar from '../components/proiect-forms/ContulBancar'
    import AjutoareStat from '../components/proiect-forms/AjutoareStat'
    import AchizitiileProiectului from '../components/proiect-forms/AchizitiileProiectului'
    import LocatieImplementare from '../components/proiect-forms/LocatieImplementare'
    import AsigurareGDPR from '../components/proiect-forms/AsigurareGDPR'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import ChangeRoutePopup from "../components/ChangeRoutePopup";
    import {changeRoute, checkFormForInputs} from "../../../../../helpers/helpers";
    import {BIconChevronUp} from 'bootstrap-vue'

    export default {
        components: {
            SketchBreadcrumb,
            TitlulProiectului,
            CAENEligibil,
            ContulBancar,
            AjutoareStat,
            AchizitiileProiectului,
            LocatieImplementare,
            AsigurareGDPR,
            ChangeRoutePopup,
            BIconChevronUp
        },
        beforeRouteLeave (to, from, next) {

            this.next = next;

            if(to.path === '/login' || to.path === '/logout')
                this.next();

            if(this.completed)
                this.next();
            else {
                if(checkFormForInputs())
                    this.showModal = true;
                else
                    this.next();
            }

        },
        data() {
            return {
                associates: null,
                companii: null,
                activeCompany: null,
                data: {},
                projectTitle: null,
                informatiiGenerale: null,
                sediuSocial: null,
                bankInfo: {},
                eligibleCAEN: {},
                state_aids: null,
                acquisitions: null,
                section: null,
                completed: false,
                showModal: false,
                next: null,
                location_address: null,
                gdpr: null,
                completedPage:{
                    caen: false,
                    ajutoareStat: false,
                    achizitii: false,
                    titlu: false,
                    gdpr: false
                },
                caenEligibil: null,
                ajutoareData: null,
                statusIMM: null,
                statusIMMMessage: '',
            }
        },
        computed: {
            companyId() {
                return this.$store.getters['m3Sketch/m3Company'] ? this.$store.getters['m3Sketch/m3Company'].id : 0
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch:{
            changeCId: {
                handler: function() {
                    this.changeCompany()
                },
                deep: false
            },
            allData: {
                handler: function() {
                    if(this.allData){
                        this.checkCompleted()
                        this.changeCompany()
                        this.projectTitle = this.allData.m3_project.mysmis ? this.allData.m3_project.mysmis.title : ''
                        this.eligibleCAEN = {
                            caen: this.allData.m3_project.caen,
                            secondary_caen: this.allData.m3_project.secondary_caen,
                            caen_saved: this.allData.m3_project.caen_saved,
                        }
                        this.bankInfo = {
                            iban: this.allData.m3_project.iban,
                            bank: this.allData.m3_project.bank
                        }
                        this.state_aids = this.allData.m3_project.state_aids
                        this.acquisitions = this.allData.m3_project.acquisitions
                        this.location_address = this.allData.m3_project.location_address
                        this.gdpr = this.allData.m3_project.gdpr
                        if(this.state_aids)
                            this.statusIMM = !!(this.state_aids.help_moneyIMM && this.state_aids.help_dateIMM)
                    }
                },
                deep: true,
                immediate: true
            },
        },
        mounted() {
            if(JSON.parse(localStorage.getItem('currentM3Company')))
                axios.get(api.API_ENDPOINTS.m3 + JSON.parse(localStorage.getItem('currentM3Company')).business_id + '/v1')
                    .then(response => {
                        this.caenEligibil = response.data;
                        this.ajutoareData = response.data.imminvest;
                        this.$store.dispatch('pageLoading/setLoading', false)
                        if(this.state_aids)
                            this.statusIMM = !!(this.state_aids.help_moneyIMM && this.state_aids.help_dateIMM)
                        else{
                            if(response.data.imminvest && response.data.imminvest[0] && response.data.imminvest[0].cui) {
                                this.statusIMM = true
                                this.statusIMMMessage = response.data.imminvest[0].stare_solicitare ? response.data.imminvest[0].stare_solicitare : ''
                            } else{
                                this.statusIMM = false
                                this.statusIMMMessage = ''
                            }
                        }
                    })
        },
        methods: {
            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
            changeCompany() {
                this.informatiiGenerale = {
                    name: this.allData.name,
                    business_type: this.allData.business_type,
                    vat_status: this.allData.vat_status,
                    imm_type: this.allData.imm_type,
                    business_id: this.allData.business_id,
                    reg_no: this.allData.reg_no,
                    main_caen: this.allData.main_caen,
                }
                this.sediuSocial = {
                    address: this.allData.address,
                    state: this.allData.state,
                    city: this.allData.city,
                    district: this.allData.district,
                    street: this.allData.street,
                    street_no: this.allData.street_no,
                    bl: this.allData.bl,
                    bl_no: this.allData.bl_no,
                    floor: this.allData.floor,
                    apt: this.allData.apt,
                    postal_code: this.allData.postal_code,
                    phone: this.allData.phone,
                    email: this.allData.email,
                }
                this.loading = false;
            },
            completePage(event, status) {
                switch (event){

                case 'caen':
                    this.completedPage.caen = status;
                    break;

                case 'titlu':
                    this.completedPage.titlu = status;
                    break;

                case 'ajutoareStat':
                    this.completedPage.ajutoareStat = status;
                    break;

                case 'achizitii':
                    this.completedPage.achizitii = status;
                    this.$emit('updateData');
                    break;

                case 'asigurareGdpr':
                    this.completedPage.gdpr = status;
                    break;

                }
                this.checkCompleted();
            },

            leavePage(event){
                changeRoute(event, this.next);

                if(!event)
                    this.showModal = false;
            },

            checkCompleted(){

                this.completed = this.completedPage.caen && this.completedPage.ajutoareStat && this.completedPage.achizitii && this.completedPage.titlu && this.completedPage.gdpr;

                this.section = {
                    section: 'proiectul-meu'
                }

                if(this.completed){
                    this.$store.dispatch('pages/addPage', this.section);
                    this.$emit('unsavedChanges', false)
                }
                else {
                    this.$store.dispatch('pages/removePage', this.section);
                }
            },
        }
    }
</script>
<style>
@media screen and (max-width: 1367px) {
  .proiectul-meu-wrapper hr.mt-5 {
    margin-top: 1rem!important;
  }
}
</style>
<style scoped>
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 99999;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.padding-box{
    padding: 20px;
    position: relative;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}
</style>
